import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import classNames from 'classnames'
import styles from './styles.scss'

const PlanTitle = styled.h2`
  background-color: ${props => props.planColor};
`
const PlanBase = styled.div`
  ${props => `
    background-color: ${props.secondaryPlanColor};
    border: 1px solid ${props.planColor}
   `}
`

const displayPrice = (price) => {
  const priceInFloat = parseFloat(price)

  if (Number.isNaN(priceInFloat)) {
    return null
  }

  const wholeNumber = Math.floor(priceInFloat)
  const decimalPart = (priceInFloat - wholeNumber).toFixed(2) * 100
  if (!decimalPart) return price

  return <span>{wholeNumber}<sup>.{decimalPart}</sup></span>
}

class PlanItem extends PureComponent {
  handlePlanClick = () => {
    this.props.onButtonClick(this.props)
  }
  togglePlan = (event) => {
    event.preventDefault()
    if (event.currentTarget.parentNode.getAttribute('data-active')) {
      event.currentTarget.parentNode.removeAttribute('data-active')
    } else {
      event.currentTarget.parentNode.setAttribute('data-active', true)
    }
    window.dispatchEvent(new Event('resize'))
  }
  renderHeader = () => {
    const {
      planColor,
      isPromo,
      promoText,
      rate,
      rateRrp,
      title,
      headerPill,
      interval,
      limit,
      pricingInfo,
    } = this.props

    const formattedRate = parseFloat(rate).toFixed(2)
    const promoTextVisible = isPromo ? promoText : ''

    return (
      <header className={styles.planHeader}>
        <PlanTitle planColor={planColor} className={styles.planTitle} onClick={this.togglePlan}>
          {title}
        </PlanTitle>
        { headerPill && (
          <div className={styles.headerPill}>
            <div className={styles.headerPillIcon}>
              <svg width="26" height="29" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  /* eslint-disable-next-line max-len */
                  d="M6.05033 27.4333C2.86543 25.4106 0.87169 21.848 2.32234 16.7417C2.32958 16.7152 2.37303 16.7176 2.37785 16.7442C3.30955 21.7188 9.65523 20.2078 8.97335 16.5824C8.58474 14.8916 7.84735 13.4241 7.48409 11.7212C7.16185 10.215 7.69167 8.6618 8.8768 7.54545C10.6799 5.84739 13.1431 4.18072 11.6647 1.11408C11.6429 1.06943 11.7009 1.02719 11.7443 1.05615C13.8503 2.41146 14.607 4.35813 13.7936 6.99391C13.6355 7.50804 13.3929 7.99802 13.102 8.46387C11.6103 10.8535 11.7069 12.6263 13.4713 13.7487C14.4875 14.3956 15.9864 14.2327 16.7323 13.3432C17.3743 12.5769 17.5059 11.4822 16.6985 10.3695C16.6804 10.3442 16.7033 10.3092 16.7371 10.314C18.3289 10.53 19.4875 11.6403 19.9449 13.2093C20.2961 14.4125 20.1296 15.6881 19.5491 16.8202C19.2787 17.3464 18.9698 17.9039 18.7296 18.4844C18.166 19.847 19.041 21.3857 20.6353 21.7152C22.2537 22.0495 24.1677 21.3568 24.9257 19.9629C24.9317 19.952 24.9498 19.9556 24.9498 19.9677C25.0258 23.6571 23.5341 26.0744 21.1977 27.5407"
                  stroke="#E71333"
                  strokeWidth="1.99333"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <span>{headerPill}</span>
          </div>
        )}
        <div className={styles.limit}>{limit}</div>
        <div className={styles.rate}>
          <div className={styles.wasPrice}>
            <div className={!rateRrp ? '' : styles.strikethrough} />
            {rateRrp && '$'}
            {displayPrice(rateRrp)}
          </div>
          {formattedRate && <div className={styles.price}>${displayPrice(formattedRate)}</div>}
          <p className={styles.interval}>per {interval}</p>
          { promoTextVisible && (<div>{promoTextVisible}</div>) }
          <div className={styles.pricing} dangerouslySetInnerHTML={{ __html: pricingInfo }} />
        </div>
      </header>
    )
  }

  render() {
    const {
      planColor,
      secondaryPlanColor,
      title,
      speedDisclaimer,
      highlightedFeature,
      features,
      buttonText,
      terms,
      eligibilityDisclaimer,
      showEligibility,
    } = this.props
    const defaultClassNames = classNames('planItem', styles.planItem, this.props.active ? '' : styles.inactive)
    return (
      <Fragment>
        <PlanBase
          className={defaultClassNames}
          key={`${title}-plan`}
          planColor={planColor}
          secondaryPlanColor={secondaryPlanColor}
        >
          {this.renderHeader()}
          <section className={styles.disclaimer} dangerouslySetInnerHTML={{ __html: speedDisclaimer }} />
          <section className={styles.content}>
            <div className={styles.highlightedFeature} dangerouslySetInnerHTML={{ __html: highlightedFeature }} />
            <div className={styles.features} dangerouslySetInnerHTML={{ __html: features }} />
            <button className={styles.genericButton} onClick={this.handlePlanClick}>
              {buttonText}
            </button>
          </section>
        </PlanBase>
        <div
          className={styles.terms}
          key={`${title}-terms`}
          dangerouslySetInnerHTML={{ __html: showEligibility ? terms + eligibilityDisclaimer : terms }}
        />
      </Fragment>
    )
  }
}

PlanItem.propTypes = {
  active: PropTypes.bool,
  planColor: PropTypes.string,
  secondaryPlanColor: PropTypes.string,
  isPromo: PropTypes.bool,
  promoText: PropTypes.string,
  rate: PropTypes.number,
  rateRrp: PropTypes.string,
  title: PropTypes.string,
  headerPill: PropTypes.string,
  interval: PropTypes.string,
  limit: PropTypes.string,
  speedDisclaimer: PropTypes.string,
  highlightedFeature: PropTypes.string,
  features: PropTypes.string,
  buttonText: PropTypes.string,
  terms: PropTypes.string,
  eligibilityDisclaimer: PropTypes.string,
  pricingInfo: PropTypes.string,
  onButtonClick: PropTypes.func,
  showEligibility: PropTypes.bool,
}

PlanItem.defaultProps = {
  active: false,
  planColor: '',
  secondaryPlanColor: '',
  isPromo: false,
  promoText: '',
  rate: 0.0,
  rateRrp: '',
  title: '',
  headerPill: '',
  interval: '',
  limit: '',
  terms: '',
  eligibilityDisclaimer: '',
  speedDisclaimer: '',
  highlightedFeature: '',
  features: '',
  buttonText: '',
  pricingInfo: '',
  onButtonClick: f => f,
  showEligibility: true,
}

export default PlanItem



// WEBPACK FOOTER //
// ./components/PlanItem/index.jsx